import { Lock } from "lucide-react";
import { Input } from "@/components/ui/input";

export default function AdminLogin({ input, setInput, onSubmit, error }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-pine px-6">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-sm border border-bone/10 bg-forest/30 p-10"
        data-testid="admin-login-form"
      >
        <Lock size={22} className="mb-6 text-terra" />
        <h1 className="mb-2 font-serif text-2xl font-semibold text-bone">Owner Dashboard</h1>
        <p className="mb-8 text-sm text-bone/60">Enter your access key to view analytics.</p>
        <Input
          type="password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Access key"
          data-testid="admin-key-input"
          className="rounded-none border-0 border-b border-bone/30 bg-transparent px-0 text-bone placeholder:text-bone/30 focus-visible:ring-0"
        />
        {error && <p className="mt-3 text-sm text-terra" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit"
          data-testid="admin-login-submit"
          className="mt-8 w-full border border-terra bg-terra px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-transparent hover:text-terra"
        >
          View Dashboard
        </button>
      </form>
    </div>
  );
}
